
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Layout from "@/components/layout/Layout";
import { useAuth } from "@/components/auth/AuthProvider";
import { LeadDetail } from "@/components/leads/LeadDetail";
import { useLead } from "@/hooks/use-lead";

export default function LeadDetailPage() {
  const { leadId } = useParams();
  const { user, isLoading: authLoading } = useAuth();
  const { lead, isLoading } = useLead(leadId);

  if (!authLoading && !user) {
    return <Navigate to="/auth/login?redirectTo=/dashboard/leads" />;
  }

  return (
    <Layout>
      <Helmet>
        <title>{lead?.nursing_home_name || 'Lead Detail'} | Grandpal</title>
      </Helmet>
      
      <div className="container py-4 md:py-8 max-w-7xl">
        <LeadDetail lead={lead} isLoading={isLoading} />
      </div>
    </Layout>
  );
}
